import { Orders } from '@/api/Orders';
import {
  AddBookingsRequest,
  AddPackageBookingsRequest,
  BookingsRequest,
  OrderResponse,
} from '@/api/data-contracts';

export const createOrderBookingApprovalMethods = (ordersApi: Orders) => {
  const requestApprovalForDraftBookings = async (
    orderId: string,
    form: BookingsRequest,
  ): Promise<void> => {
    await ordersApi.handleDraftBookings(orderId, form);
  };

  const requestApprovalForDraftPackageBookings = async (
    orderId: string,
    form: BookingsRequest,
  ): Promise<void> => {
    await ordersApi.handleDraftPackageBookings(orderId, form);
  };

  const addBookingsToOrder = async (
    orderId: string,
    form: AddBookingsRequest,
  ): Promise<OrderResponse> => {
    const { data } = await ordersApi.addBookings(orderId, form);
    return data;
  };

  const addPendingBookingsToOrder = async (
    orderId: string,
    form: AddBookingsRequest,
  ): Promise<OrderResponse> => {
    const { data } = await ordersApi.addPendingBookings(orderId, form);
    return data;
  };

  const addPackageBookingsToOrder = async (
    orderId: string,
    form: AddPackageBookingsRequest,
  ): Promise<OrderResponse> => {
    const { data } = await ordersApi.addPackageBookings(orderId, form);
    return data;
  };

  const addPendingPackageBookingsToOrder = async (
    orderId: string,
    form: AddPackageBookingsRequest,
  ): Promise<OrderResponse> => {
    const { data } = await ordersApi.addPendingPackageBookings(orderId, form);
    return data;
  };

  const approveMultipleBookingsFromOrder = async (
    orderId: string,
    bookingIds: string[],
  ): Promise<OrderResponse> => {
    const { data } = await ordersApi.approveBookings(orderId, { bookingIds });
    return data;
  };

  const approveMultiplePackageBookingsFromOrder = async (
    orderId: string,
    bookingIds: string[],
  ): Promise<OrderResponse> => {
    const { data } = await ordersApi.approvePackageBookings(orderId, {
      bookingIds,
    });
    return data;
  };

  const approveAllBookingsFromOrder = async (orderId: string): Promise<OrderResponse> => {
    const { data } = await ordersApi.approveAllBookings(orderId);
    return data;
  };

  const rejectMultipleBookingsFromOrder = async (
    orderId: string,
    bookingIds: string[],
    rejectionReason?: string,
  ): Promise<OrderResponse> => {
    const { data } = await ordersApi.rejectBookings(orderId, { bookingIds, rejectionReason });
    return data;
  };

  const rejectMultiplePackageBookingsFromOrder = async (
    orderId: string,
    bookingIds: string[],
    rejectionReason?: string,
  ): Promise<OrderResponse> => {
    const { data } = await ordersApi.rejectPackageBookings(orderId, {
      bookingIds,
      rejectionReason,
    });
    return data;
  };

  const rejectAllBookingsFromOrder = async (
    orderId: string,
    rejectionReason?: string,
    additionalInformation?: string,
  ): Promise<OrderResponse> => {
    const rejectData = {
      rejectionReason: rejectionReason,
      additionalInformation: additionalInformation,
    };
    const { data } = await ordersApi.rejectAllBookings(orderId, rejectData);
    return data;
  };

  const deleteBookingsFromOrder = async (orderId: string, form: BookingsRequest): Promise<void> => {
    await ordersApi.deleteBookings(orderId, form);
  };

  const deletePackageBookingsFromOrder = async (
    orderId: string,
    form: BookingsRequest,
  ): Promise<void> => {
    await ordersApi.deletePackageBookings(orderId, form);
  };

  return {
    requestApprovalForDraftBookings,
    requestApprovalForDraftPackageBookings,
    addBookingsToOrder,
    addPendingBookingsToOrder,
    addPackageBookingsToOrder,
    addPendingPackageBookingsToOrder,
    approveMultipleBookingsFromOrder,
    approveMultiplePackageBookingsFromOrder,
    approveAllBookingsFromOrder,
    rejectMultipleBookingsFromOrder,
    rejectMultiplePackageBookingsFromOrder,
    rejectAllBookingsFromOrder,
    deleteBookingsFromOrder,
    deletePackageBookingsFromOrder,
  };
};
